/* This file is autogenerated, see readme.md for instructions */
import ShopSvgIcon from '@bloomreach/banana-theme/icons/shop.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ShopIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ShopSvgIcon />
    </Icon>
  );
});

ShopIcon.displayName = 'ShopIcon';

export default ShopIcon;
